module.exports = __webpack_public_path__ + "img/galerie-18.c1ea406e.jpg";